import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { format } from 'date-fns';
import { addApiError } from '@features/advanced-errors/store/slice';
import { ApiError } from '@features/advanced-errors/types/ApiError';
import { hasOwnPropertyTS, unknownHasOwnPropertyTS } from '@utils/typescriptGuards';



const apiErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
	
	if (isRejectedWithValue(action) && typeof action.type === 'string' && /^baseApi\/[\w]*\/rejected$/.test(action.type)) {

		// exceptions
		if (action.meta.arg && unknownHasOwnPropertyTS(action.meta.arg, 'endpointName') && action.meta.arg.endpointName === "getUserData"
			&& unknownHasOwnPropertyTS(action.payload, 'originalStatus') && action.payload.originalStatus === 404) {
			return next(action);
		}
		
		console.warn('Api call rejected');
		console.warn({ error: action.error });
		console.warn({ meta: action.meta });
		console.warn({ payload: action.payload });
		console.warn({ type: action.type });

		if (process.env.SHOW_ADVANCED_ERRORS === 'TRUE') {
			const newError: ApiError = {
				type: action.type ? action.type : 'default',
				message: action.error && action.error.message ? action.error.message : 'default',
				requestId: hasOwnPropertyTS(action, 'meta') ? action.meta.requestId : 'default',
				timestamp: format(new Date(), 'MM/dd/yyyy - HH:mm:ss'),
	
				actionPayload: hasOwnPropertyTS(action, 'payload') ? {
					error: unknownHasOwnPropertyTS(action.payload, 'error') && typeof action.payload.error === 'string'
						? action.payload.error
						: 'default',
					status: unknownHasOwnPropertyTS(action.payload, 'status') && typeof action.payload.status === 'string'
						? action.payload.status
						: 'default',
				} : undefined,
	
				meta: hasOwnPropertyTS(action, 'meta') ? {
					endpoint: action.meta.arg && hasOwnPropertyTS(action.meta.arg, 'endpointName') && typeof action.meta.arg.endpointName === 'string'
						? action.meta.arg.endpointName
						: 'default',
					
					originalArgs: action.meta.arg && hasOwnPropertyTS(action.meta.arg, 'originalArgs') && typeof action.meta.arg.originalArgs === 'string'
						? action.meta.arg.originalArgs
						: 'default',
					
					type: action.meta.arg && hasOwnPropertyTS(action.meta.arg, 'type') && typeof action.meta.arg.type === 'string'
						? action.meta.arg.type
						: 'default'
				} : undefined,
				
				request: hasOwnPropertyTS(action, 'meta') && hasOwnPropertyTS(action.meta, 'baseQueryMeta') && unknownHasOwnPropertyTS(action.meta.baseQueryMeta, 'request') ? {
					method: unknownHasOwnPropertyTS(action.meta.baseQueryMeta.request, 'method') && typeof action.meta.baseQueryMeta.request.method === 'string'
						? action.meta.baseQueryMeta.request.method
						: 'default',
					url: unknownHasOwnPropertyTS(action.meta.baseQueryMeta.request, 'url') && typeof action.meta.baseQueryMeta.request.url === 'string'
						? action.meta.baseQueryMeta.request.url
						: 'default'
				} : undefined,
			};
	
			api.dispatch(addApiError(newError));
		}
	}
	return next(action);
}

export default apiErrorLogger;